/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Description_Item_4Inputs */

const es_tyc_description_item_4 = /** @type {(inputs: Tyc_Description_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistemas de credenciales y gestion de usuarios`)
};

const en_tyc_description_item_4 = /** @type {(inputs: Tyc_Description_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credential systems and user management`)
};

/**
* | output |
* | --- |
* | "Credential systems and user management" |
*
* @param {Tyc_Description_Item_4Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_description_item_4 = /** @type {((inputs?: Tyc_Description_Item_4Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Description_Item_4Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_description_item_4(inputs)
	return en_tyc_description_item_4(inputs)
});
export { tyc_description_item_4 as "tyc.description.item_4" }